<div @themeChangeOpacity *ngIf="!themeReady"
  class="text-white fixed flex flex-col justify-center items-center w-screen h-screen bg-black/60 backdrop-blur-3xl "
  style="z-index: 9999999999999999999999;">

  <div class="theme-toggle {{dark ? 'theme-toggle--toggled' : ''}}">
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="1em" height="1em" fill="currentColor"
      class="theme-toggle__expand w-64 h-64" viewBox="0 0 32 32">
      <clipPath id="theme-toggle__expand__cutout">
        <path d="M0-11h25a1 1 0 0017 13v30H0Z" />
      </clipPath>
      <g clip-path="url(#theme-toggle__expand__cutout)">
        <circle cx="16" cy="16" r="8.4" />
        <path
          d="M18.3 3.2c0 1.3-1 2.3-2.3 2.3s-2.3-1-2.3-2.3S14.7.9 16 .9s2.3 1 2.3 2.3zm-4.6 25.6c0-1.3 1-2.3 2.3-2.3s2.3 1 2.3 2.3-1 2.3-2.3 2.3-2.3-1-2.3-2.3zm15.1-10.5c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3zM3.2 13.7c1.3 0 2.3 1 2.3 2.3s-1 2.3-2.3 2.3S.9 17.3.9 16s1-2.3 2.3-2.3zm5.8-7C9 7.9 7.9 9 6.7 9S4.4 8 4.4 6.7s1-2.3 2.3-2.3S9 5.4 9 6.7zm16.3 21c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3zm2.4-21c0 1.3-1 2.3-2.3 2.3S23 7.9 23 6.7s1-2.3 2.3-2.3 2.4 1 2.4 2.3zM6.7 23C8 23 9 24 9 25.3s-1 2.3-2.3 2.3-2.3-1-2.3-2.3 1-2.3 2.3-2.3z" />
      </g>
    </svg>
  </div>

  <h2 *ngIf="!dark">Tema chiaro attivo</h2>
  <h2 *ngIf="dark">Tema scuro attivo</h2>
</div>

<div *ngIf="textReady" id="global-content-container" class="main-saas-container ">

  <router-outlet>
    <!-- <span *ngIf="showLoader" class="loading"></span> -->

    <!-- <div *ngIf="showLoader" class="no-freeze-spinner">
      <div id="no-freeze-spinner">
        <div>
          <i>
            <img *ngIf="showLoader" src="{{loaderLogo}}">
          </i>
          <div>
          </div>
        </div>
      </div>
    </div> -->

    <div *ngIf="showLoader">
      <app-loading-animation></app-loading-animation>
    </div>

    <div *ngIf="showLoader" class="overlay"></div>
  </router-outlet>

  <div *ngIf="showFetchPopup" class="card w-1/6 fixed bottom-0 right-0 flex justify-between">
    <p>Aggiornamento dati in corso</p>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
      class="w-6 h-6  animate-spin text-primary-500">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
    </svg>
  </div>





</div>



<div class="fixed top-0 h-full w-full bg-primary-950/80 backdrop-blur-2xl flex justify-center align-middle items-center"
  style="z-index: 9999999;" *ngIf="reloading">



  <div
    class="flex flex-col w-full h-full justify-center items-center  text-primary-200 text-center bg-gradient-to-b from-white/30 to-transparent">
    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-alert-octagon-filled" class="w-16 h-16 "
      viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round"
      stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path
        d="M14.897 1a4 4 0 0 1 2.664 1.016l.165 .156l4.1 4.1a4 4 0 0 1 1.168 2.605l.006 .227v5.794a4 4 0 0 1 -1.016 2.664l-.156 .165l-4.1 4.1a4 4 0 0 1 -2.603 1.168l-.227 .006h-5.795a3.999 3.999 0 0 1 -2.664 -1.017l-.165 -.156l-4.1 -4.1a4 4 0 0 1 -1.168 -2.604l-.006 -.227v-5.794a4 4 0 0 1 1.016 -2.664l.156 -.165l4.1 -4.1a4 4 0 0 1 2.605 -1.168l.227 -.006h5.793zm-2.887 14l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z"
        stroke-width="0" fill="currentColor" />
    </svg>
    <h1>Nuova versione rilevata</h1>

    <button 
      class=" bg-white/20 hover:bg-white/50 hover:text-primary-600 backdrop-blur-2xl flex flex-col p-5 text-center justify-center items-center mt-10 rounded-2xl "
      (click)="refreshPage()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-16 h-16 ">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
      </svg>
      <h2>Aggiorna la pagina</h2>
    </button>

    <button *ngIf="ignoreButton"
      class=" bg-white/20 hover:bg-white/50 hover:text-primary-600 backdrop-blur-2xl flex flex-col p-5 text-center justify-center items-center mt-10 rounded-2xl "
      (click)="reloading = false">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" class="w-16 h-16 "
        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round"
        stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6l-12 12" />
        <path d="M6 6l12 12" />
      </svg>
      <h2>Ignora l'avviso</h2>
    </button>

  </div>

</div>

<!--Spinner-->
<div class="app-bg" *ngIf="!textReady">
  <div class="fixed flex w-screen h-screen justify-center items-center bg-primary-950/30 backdrop-blur-2xl" >
    <app-loading-animation></app-loading-animation>
  </div>

</div>